import { MessageError, MessageWarning, MesssageBoxQuestion } from '@/components/util/MessageBox'
import router from '@/router/index.js';
import { doLogin, doSmsLogin } from '../../api/user.js'

const user = {
	state: {
		uuid: '',
		// 登录令牌
		token: '',
		// 用户id
		userid: '',
		// 用户名
		name: '',
		// 用户头像
		avatar: '',
		// 登录次数
		loginNum: null,
		// 用户角色列表
		roles: [],
		// 用户权限列表
		permissions: []
	},

	// 改变state
	mutations: {
		SET_UUID: (state, uuid) => {
			state.uuid = uuid
		},
		SET_TOKEN: (state, token) => {
			state.token = token
		},
		SET_USERID: (state, userid) => {
			state.userid = userid
		},
		SET_NAME: (state, name) => {
			state.name = name
		},
		SET_AVATAR: (state, avatar) => {
			state.avatar = avatar
		},
		SET_LOGIN_NUM: (state, loginNum) => {
			state.loginNum = loginNum
		},
		SET_ROLES: (state, roles) => {
			state.roles = roles
		},
		SET_PERMISSIONS: (state, permissions) => {
			state.permissions = permissions
		},
		// 重置
		RESET_STATE(state) {
			state.token = ''
			state.userid = ''
			state.name = ''
			state.loginErrNum = 8
			state.avatar = ''
			state.roles = []
			state.permissions = []
			// 清除浏览器缓存中的token
			localStorage.removeItem('nxzj_token')
		}
	},

	actions: {
		// 登录方法
		async doLogin({ commit, dispatch }, user) {
			await doLogin(user).then(res => {
				switch (res.result) {
					case '1':
						commit('SET_TOKEN', res.token)
						// 保存token到浏览器缓存
						localStorage.setItem('nxzj_token', res.token)
						commit('SET_USERID', res.userid)
						commit('SET_AVATAR', res.photo)
						commit('SET_NAME', res.name)
						// if (!res.photo) {
						// 	MesssageBoxQuestion('请完善照片信息！').then(() => {
						// 		router.push({ path: 'userInfo/5' });
						// 	})
						// }
						break;
					case '2':
						MessageWarning("账号不存在");
						break;
					case '3':
						MessageWarning("账号未激活");
						break;
					case '4':
						// 登录错误次数提示
						commit('SET_LOGIN_NUM', res.loginErrNum)
						let numLast = res.loginErrNum;
						MessageWarning('帐号或密码错误，每天有8次输入错误机会，你还有' + (8 - numLast) +
							'次机会！如您忘记账号或密码，可在电脑端点击“忘记密码”找回（账号需绑定手机号码）！');
						break;
					case '5':
						MessageWarning("帐号或密码错误次数超过8次,请明日登录");
						break;
				}
			})
		},
		// 手机验证码登录
		async smsLogin({ commit, dispatch }, user) {
			await doSmsLogin(user).then(res => {
				switch (res.result) {
					case '1':
						commit('SET_TOKEN', res.token)
						// 保存token到浏览器缓存
						localStorage.setItem('nxzj_token', res.token)
						break;
					case '2':
						MessageWarning("账号不存在");
						break;
					case '3':
						MessageWarning("账号未激活");
						break;
					case '4':
						MessageWarning("短信验证错误");
						break;
				}
			})
		}
	}
}

export default user